export default "/images/plane.svg?5f909e6937819a2ebd793e3a8ff60cd0";